// Public Privacy Policy page (/privacy).
import React from "react";
import { PrivacyBody } from "./legalContent";

export default function PrivacyPage() {
  return (
    <div style={{ maxWidth: 820, margin: "0 auto", padding: "32px 20px 64px" }}>
      <h1 style={{ fontSize: 24, color: "#0f172a", marginBottom: 16 }}>Privacy Policy</h1>
      <PrivacyBody />
    </div>
  );
}
